<template>
  <div id="wrap">
    <div class="login-in">
      <img class="z1 log-bg-img" src="../assets/img/loginbg.png" height="100%"  alt="">
      <div class="login-box login-position" v-show="!forget">
        <div class="login-title">极客晨星编程课堂</div>
        <div class="login-tab">
          <div class="tab-item" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">密码登录</div>
          <div class="tab-item" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">验证码登录</div>
        </div>
        <div class="login-item">
          <div class="input-box">
            <img src="../assets/img/tel.png" alt />
            <el-dropdown class="my-el-dropdown dropdown-position" placement="bottom-start" trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{dropdownDefault}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="my-dropdown1">
                <el-dropdown-item class="my-el-dropdown-item"
                v-for="(item,index) in dropdownList" :key="index" :command="item.en">
                  <p>{{item.zh}}</p>
                  <p>{{item.en}}</p>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="line line-phone"></div>
            <input class="input-phone" type="text" v-model="mobile" maxlength="11" oninput = "value=value.replace(/[^\d]/g,'')" placeholder="手机号码" />
          </div>
          <div class="input-box" v-show="tabIndex === 0">
            <img src="../assets/img/password.png" alt />
            <div class="line"></div>
            <input type="text" v-model="passwd"  v-show="pwdshow" maxlength="16" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" minlength="6" placeholder="密码" />
            <input type="password" v-model="passwd" v-show="!pwdshow" maxlength="16" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" minlength="6" placeholder="密码" />
            <div class="pwdview">
              <img v-show="pwdshow" @click="pwdshow = !pwdshow" src="../assets/img/password-view.png" alt="显示密码">
              <img v-show="!pwdshow"  @click="pwdshow = !pwdshow" src="../assets/img/password-not-view.png" alt="隐藏密码">
              </div>
          </div>
          <div class="input-box flex-box" v-show="tabIndex === 1">
            <img src="../assets/img/key.png" alt />
            <div class="line"></div>
            <input type="text" v-model="verificationcode" maxlength="6" oninput = "value=value.replace(/[^\d]/g,'')" placeholder="验证码" />
            <div class="btn" v-show="!codeInterval" @click="getcode">获取验证码</div>
            <div class="btn" v-show="codeInterval">{{ codeSeconds }}秒</div>
          </div>
          <div class="tips" v-show="tabIndex === 0"  @click="forget = 1">忘记密码？</div>
        </div>
        <div class="next-btn z2" v-if="!tabIndex" @click="login_password">登录</div>
        <div class="next-btn z2" v-if="tabIndex" @click="login_code">登录</div>
      </div>
      <!-- 忘记密码 -->
      <div class="login-box login-position forget-position" v-show="forget">
        <div id="back" @click="forget = 0"><img src="../assets/img/back.png" alt=""></div>
        <div class="login-title" id="login-title-changepwd">修改密码</div>

        <div class="login-item" id="forget-login-item">
          <div class="input-box">
            <img src="../assets/img/tel.png" alt />
            <el-dropdown class="my-el-dropdown dropdown-position" placement="bottom-start" trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{dropdownDefault}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="my-dropdown1">
                <el-dropdown-item class="my-el-dropdown-item"
                v-for="(item,index) in dropdownList" :key="index" :command="item.en">
                  <p>{{item.zh}}</p>
                  <p>{{item.en}}</p>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="line line-phone"></div>
            <input class="forinput input-phone" type="text" v-model="mobile" placeholder="手机号" />
          </div>
          <div class="input-box flex-box" >
            <img src="../assets/img/key.png" alt />
            <div class="line"></div>
            <input type="text" v-model="verificationcode" placeholder="验证码" />
            <div class="btn" v-show="!codeInterval" @click="getcode">获取验证码</div>
            <div class="btn" v-show="codeInterval">{{ codeSeconds }}秒</div>
          </div>
          <div class="input-box">
            <img src="../assets/img/password.png" alt />
            <div class="line"></div>
            <!-- <input type="text" v-model="passwd"  v-show="pwdshow" placeholder="设置密码" />
            <input type="password" v-model="passwd" v-show="!pwdshow" placeholder="设置密码" /> -->
            <input type="password" v-model="passwd"  placeholder="设置密码" />
            <!-- <div class="pwdview">
              <img v-show="!pwdshow" @click="pwdshow = !pwdshow" src="../assets/img/password-view.png" alt="显示密码">
              <img v-show="pwdshow"  @click="pwdshow = !pwdshow" src="../assets/img/password-not-view.png" alt="隐藏密码">
            </div> -->
          </div>
          <div class="input-box">
            <img src="../assets/img/password.png" alt />
            <div class="line"></div>
            <!-- <input type="text" v-model="passwd"  v-show="pwdshow" placeholder="重复密码" /> -->
            <!-- <input type="password" v-model="passwdrepeat" v-show="!pwdshow" placeholder="重复密码" /> -->
            <input type="password" v-model="passwdrepeat" placeholder="重复密码" />
            <!-- <div class="pwdview">
              <img v-show="!pwdshow" @click="pwdshow = !pwdshow" src="../assets/img/password-view.png" alt="显示密码">
              <img v-show="pwdshow"  @click="pwdshow = !pwdshow" src="../assets/img/password-not-view.png" alt="隐藏密码">
            </div> -->
          </div>
        </div>

        <div class="next-btn" id="forbtn" @click="login_changepwd">确认修改</div>

      </div>
    </div>
  </div>
</template>

<script>
import { log } from 'util'
export default {
  name: 'login',
  data () {
    return {
      mobile: '',
      passwd: '',
      passwdrepeat: '',
      pwdshow: 0,
      verificationcode: '',
      // 控制验证码登陆密码登陆切换 0密码 1验证码
      tabIndex: 0,
      // 忘记密码 0未点击  1点击忘记
      forget: 0,
      // codeInterval设置为空，允许发送验证码
      codeInterval: null,
      codeSeconds: 60,
      dropdownDefault: "+86",
      dropdownList: [
        { zh: "中国大陆", en: "+86" },
        { zh: "中国香港", en: "+852" },
        { zh: "中国澳门", en: "+853" },
        { zh: "中国台湾", en: "+886" },
        { zh: "日本", en: "+81" },
        { zh: "韩国", en: "+82" },
        { zh: "美国", en: "+1" },
        { zh: "加拿大", en: "+1" },
        { zh: "英国", en: "+44" },
        { zh: "法国", en: "+33" },
        { zh: "德国", en: "+49" },
        { zh: "俄罗斯", en: "+7" },
        { zh: "西班牙", en: "+34" },
        { zh: "新加坡", en: "+65" },
        { zh: "马来西亚", en: "+60" },
        { zh: "泰国", en: "+66" },
        { zh: "印度", en: "+91" },
        { zh: "澳大利亚", en: "+61" },
        { zh: "新西兰", en: "+64" }
      ]
    }
  },
  // vue生命周期钩子 清除计时器
  beforeDestroy () {
    window.clearInterval(this.codeInterval)
    this.codeInterval = null
    // console.log("生命周期销毁");
  },

  methods: {
    handleCommand(command) {
      this.dropdownDefault = command;
    },
    // 登陆：账号密码登陆
    login_password () {
      // 判断账号是否合法 status校验状态
      if (!this.verify_mobile.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_mobile.msg)
        return
      }
      // 判断密码是否输入 status状态
      if (!this.verify_password.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_password.msg)
        return
      }
      //  校验通过，调用账号密码登录接口请求
      this.loginHandler_password()
      // this.$message('登录')
      console.log('password账号密码登陆')
    },
    // 登陆：验证码登陆
    login_code () {
      // 判断账号是否合法 status校验状态
      if (!this.verify_mobile.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_mobile.msg)
        return
      }
      // 判断验证码是否填写
      // this.check_code()
      if (!this.verify_code.status) {
        // 页面弹出提示（）msg来源于computed内verify的msg
        this.$message.warning(this.verify_code.msg)
        return
      }
      //  调用账号验证码登录接口请求（需要写验证码登陆接口）
      this.loginHandler_code()
      // this.$message('登录')
      console.log('code验证码登陆')
    },
    // 登陆：修改密码并登陆
    login_changepwd () {
      // 验证手机
      if (!this.verify_mobile.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_mobile.msg)
        return
      }

      // 判断验证码是否填写
      // this.check_code()
      if (!this.verify_code.status) {
        // 页面弹出提示（）msg来源于computed内verify的msg
        this.$message.warning(this.verify_code.msg)
        return
      }
      // 判断密码是否输入 status状态
      if (!this.verify_password.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_password.msg)
        return
      }
      // 验证两次输入
      if (!this.verify_passwdrepeat.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_passwdrepeat.msg)
        return
      }
      // 验证手机号
      // this.check_momile()
      // 验证验证码
      // this.check_code()
      // 验证密码
      // this.checke_password()
      // 验证重复密码
      // this.check_passwdrepeat()
      // 发送请求
      console.log('修改并登陆')
      this.loginHandler_changepwd()
    },
    // 请求：账号密码登陆请求
    loginHandler_password () {
      this.axios.post('/signin.json', {
        mobile: `${this.dropdownDefault}-${this.mobile}`,
        passwd: this.passwd
      }).then((res) => {
        console.log("密码登陆成功状态返回")
        console.log("跳转主页");

        this.$router.push('/')
      }).catch((error) => {
        if (error.response) {
          // 验证失败提示
          this.$message.error('账号密码错误')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    // 请求：验证码登陆请求
    loginHandler_code () {
      this.axios.post('/signin.json', {
        // mobile: this.mobile,
        'mobile': `${this.dropdownDefault}-${this.mobile}`,
        'verification-code': this.verificationcode
      }).then((res) => {
        console.log('验证码登陆成功状态返回')
        this.$router.push('/')
      }).catch((error) => {
        if (error.response) {
          // 验证失败提示
          this.$message.error('账号验证码错误')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    // 请求：获取验证码请求
    loginHandler_getcode () {
      this.axios.post('/verifycode', {
        // phone: this.mobile
        phone: `${this.dropdownDefault}-${this.mobile}`
      }).then((res) => {
        // this.$router.push('/')
        console.log('后台发送验证码')

        console.log(res)
      }).catch((error) => {
        if (error.response) {
          // 验证失败提示
          this.$message.error('获取验证码错误')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    // 请求：修改密码并登陆请求
    loginHandler_changepwd () {
      this.axios.post('/forgotpasswd.json', {
        // 'mobile': this.mobile,
        'mobile': `${this.dropdownDefault}-${this.mobile}`,
        'verification-code': this.verificationcode,
        'passwd': this.passwd,
        'passwdrepeat': this.passwd
      }).then((res) => {
        // 修改成功跳转
        this.$router.push('/')
        console.log('跳转主页')

        console.log(res)
      }).catch((error) => {
        if (error.response) {
          // 验证失败提示
          this.$message.error('修改失败')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    // 获取验证码
    getcode () {
      // 验证是否输入手机号
      if (!this.verify_mobile.status) {
        // 页面弹出提示（
        this.$message.warning(this.verify_mobile.msg)
        return
      }
      // 调用接口获取登陆验证码
      this.loginHandler_getcode()
      // 启动验证码计时器
      this.countdown()
    },
    // 验证码计时器
    countdown () {
      // 验证码计时器 60秒 codeInterval状态切换按钮倒计时或者获取验证码
      this.codeInterval = window.setInterval(() => {
        if (this.codeSeconds === 1) {
          // 清除计时器
          window.clearInterval(this.codeInterval)
          // 将codeInterval设置为空，允许发送验证码 发送后用codeInterval设置倒计时
          this.codeInterval = null
          // 验证码倒计时重置为60秒
          this.codeSeconds = 60
          return
        }
        // 每秒倒计时-1
        this.codeSeconds--
      }, 1000)
    }
  },
  computed: {

    // 验证手机号
    verify_mobile () {
      if (!this.mobile) {
        return {
          // 返回手机号验证状态
          status: false,
          msg: '请输入正确的手机号'
        }
      }
      // 手机号校验通过
      return { status: true }
    },
    // 账号密码验证规则
    verify_password () {
      // 验证是否输入密码
      if (!this.passwd) {
        return {
          status: false,
          msg: '请正确输入密码'
        }
      }
      // 密码校验 输入通过
      return { status: true }
    },
    verify_passwdrepeat () {
      // 验证重复输入密码是否与密码一样
      if (this.passwd != this.passwdrepeat) {
        return {
          status: false,
          msg: '两次输入密码不一致'
        }
      }
      // 密码校验 两次输入一致
      return { status: true }
    },
    // 验证码校验规则
    verify_code () {
      let reg = /^\d{6}$/
      if (!reg.test(this.verificationcode)) {
        return {
          // 返回验证码状态
          status: false,
          msg: '请输入正确的验证码'
        }
      }

      // 输入了验证码
      return { status: true };
    }
  }
}
</script>

<style lang="stylus" scoped>
input::-moz-placeholder{color:gary;}              //ff
input::-webkit-input-placeholder{color:gary;}     //chrome,safari
input:-ms-input-placeholder{color:gary;}          //ie10
.my-el-dropdown{
  // position: relative;
}
.my-el-dropdown-item{
  display: flex;
  justify-content: space-between;
}
.my-dropdown{
  width: 320px;
  height: 300px;
  overflow: auto;
}
.my-dropdown1{
  width: 320px;
  height: 400px;
  overflow: auto;
}
html,body{margin:0;padding:0}
#wrap{
  background:#E5FFED
  background-image: url(../assets/img/bgtest.png)
  // background:url(../assets/img/bgtest.png) left top no-repeat;
  background-size: 100% 100%;
  height 100vh
  overflow hidden
  display flex
  overflow hidden
  // 最小宽度
  min-width 922px

  .login-in{


    // width 700px
    width 922px
    min-width 922px
    // height 400px
    height 527px
    margin 0 auto
    border:7px solid #00AEE1;
    border-radius 23px
    background:#fff
    // background-image: url(../assets/img/loginbg.png)
    // background-repeat:no-repeat;

	  // background-attachment:fixed;

	  // background-position:top;
    background-size  auto 100%
    box-shadow:0px 1px 13px 0px rgba(27,148,239,0.85);

    // box-shadow:0px 2px 20px 0px rgba(27,148,239,0.85);
    // overflow hidden
    position relative

    align-self center

    login-bg-img{
      display inline-block
      float left
      position absolute
      top 0
      left 0
    }
  }
}

// #wrap:before{content: ""; display: block; padding-top: 0%;}
// 登陆整体位置
.login-position{
  position absolute
  top 48px
  left 432px
}
// 修改密码整体位置
.forget-position{
  position absolute
  top 16px
  left 432px
}
#forget-login-item{
  position absolute
  top 40px
  left 80px
}
#forbtn{
  //修改密码btn
  position absolute
  top 346px
  left 80px

}

#back{
  display inline-block
  position absolute
  // left -540px
  // top -80px
  left 110px
  top 10px
  img{
    width 35px
    height 26px
  }

}
//  修改密码文字位置
#login-title-changepwd{
  position absolute
  // top -31px
  // left 166px
  top -5px
  left 200px
}
// 登陆框样式
.login-box {
  // width: 259px;
  width:341px
  height: 450px;
  // border: 2px solid orange;
  border-radius: 15px;
  margin: 15px auto;
  padding: 0 80px;
  // position absolute
  // top 0px
  // left 310px

  .login-title {
    color: #565656
    text-align: center;
    font-size: 20px;
    padding-top: 15px;
    position absolute
    top -7px
    left 143px
    // 1625
    font-size:26px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(86,86,86,1);
    line-height:37px;
  }

  .login-tab {
    display: flex;
    font-size :14px
    padding-top: 30px;
    border-bottom: 2px solid #cccccc;
    position relative
    top 43px
    left 0px

    .tab-item {
      flex: 1;
      text-align: center;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      position: relative;
      color: #cccccc;
      // 1625
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(115,115,115,1);
      line-height:26px;

      &.active {
        color: #000;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: -2px;
          left: 0;
          // background: #878787;
          background: orange;
        }
      }
    }
  }

  .login-item {
    padding-top: 10px;
    height: 160px;
    position relative
    top 40px

    .input-box {
      position: relative;
      margin-top: 20px;
      // 显示密码隐藏密码
      .pwdview img{
        left 85%
      }
      &.flex-box {
        display: flex;
        justify-content: space-between;

        input {
          width: 185px;
          // 1625
          width:206px;
        }

        .btn {
          width: 95px;
          border-radius: 22px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          color: #ffffff;
          background: orange;
          cursor: pointer;
          font-size 14px
          margin-left 11px
          // 1625
          width:125px;
          height:58px;
          background:rgba(254,188,43,1);
          border-radius:29px;
          line-height: 58px;
          font-size:18px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(255,255,255,1);

        }
      }

      img {
        width: 16px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 24px;
        margin: auto;
      }

      //----
      .dropdown-position{
        position: absolute;
        top: 20px;
        bottom: 0;
        left: 50px;
      }

      .line {
        position: absolute;
        width: 2px;
        height: 22px;
        background: #cccccc;
        top: 0;
        bottom: 0;
        left: 50px;
        margin: auto;
      }
      .line-phone{
        left: 105px;
      }
      .input-phone{
        text-indent: 120px !important;
      }
      input {
        width: 100%;
        line-height: 40px;
        border: 1px solid #cccccc;
        border-radius: 30px;
        outline: none;
        text-indent: 70px;
        box-sizing: border-box;
        // 1625
        width:341px;
        height:58px;
        border-radius:29px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        // color:rgba(179,179,179,1);
        color:black
        line-height:22px;

        &:focus {
          border-color: orange;

        }
      }
    }

    .tips {
      text-align: right;
      padding-top: 7px;
      font-size: 11px;
      color: #878787;
      cursor: pointer;
      // 1625

      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(127,127,127,1);
      line-height:20px;
    }
  }

  .next-btn {
    cursor:pointer;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    // font-weight: bold;
    background: orange;
    border-radius: 30px;
    font-size: 22px;
    margin-top: 49px;
    // 1625
    font-size:29px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:58px;
    text-shadow:0px 0px 3px rgba(189,93,0,0.5);
    // 新样式覆盖
    width:341px;
    height:58px;
    background:linear-gradient(135deg,rgba(255,220,75,1) 0%,rgba(253,182,36,1) 100%);
    border-radius:29px;
    position absolute
    top 294px
  }
}
.z2{
  z-index 2
}
// 遮盖自动输入
input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
</style>
